export  const  config= {
        apiKey: "AIzaSyCWLQ76blBiOIOpOgQQ_e0M93urmLgl2JU",
        authDomain: "apisailor.com",
        databaseURL: "https://sailor-52386.firebaseio.com",
        projectId: "sailor-52386",
        storageBucket: "sailor-52386.appspot.com",
        messagingSenderId: "1012603896187",
        timestampsInSnapshots: true
 };
